import { default as auth } from "@/modules/auth/services";
import { default as users } from "@/modules/users/services";
import { default as acl } from "@/modules/acl/services";
import { default as areas } from "@/modules/areas/services";
import { default as categorias } from "@/modules/categorias/services";
import { default as estados } from "@/modules/estados/services";
import { default as municipios } from "@/modules/municipios/services";
import { default as tipos_instrumentos } from "@/modules/tipos_instrumentos/services";
import { default as tipos_concedentes } from "@/modules/tipos_concedentes/services";
import { default as tipos_instituicoes } from "@/modules/tipos_instituicoes/services";
import { default as moedas } from "@/modules/moedas/services";
import { default as concedentes } from "@/modules/concedentes/services";
import { default as concedentes_contatos } from "@/modules/concedentes_contatos/services";
import { default as relatorios } from "@/modules/relatorios/services";
import { default as oportunidades } from "@/modules/oportunidades/services";
import { default as parceiros } from "@/modules/parceiros/services";
import { default as clientes } from "@/modules/clientes/services";
import { default as planos } from "@/modules/planos/services";
import { default as files } from "@/modules/files/services";
import { files_estruturas } from "@/modules/files/services";
import { files_categorias } from "@/modules/files/services";
import { default as contrapartidas } from "@/modules/contrapartidas/services";
import { default as cnpj } from "@/modules/cnpj/services";
import { default as extratores } from "@/modules/extratores/services";
import { default as perfis } from "@/modules/perfis/services";

import { beneficios_services } from "@/modules/oportunidades/services";
import { beneficios_concedentes_services } from "@/modules/oportunidades/services";
import { emendas_services } from "@/modules/oportunidades/services";

const services = {
  auth,
  acl,
  users,
  areas,
  categorias,
  estados,
  municipios,
  tipos_instrumentos,
  tipos_concedentes,
  tipos_instituicoes,
  moedas,
  concedentes,
  concedentes_contatos,
  relatorios,
  oportunidades,
  parceiros,
  clientes,
  planos,
  files,
  files_estruturas,
  files_categorias,
  contrapartidas,
  cnpj,
  beneficios_services,
  beneficios_concedentes_services,
  emendas_services,
  extratores,
  perfis,
};

export default services;
